import config from '../../config';
import { trackEvent } from '../analytics/tracking';

// Custom attributes: They have to be configured in Intercom prior to use
export const SIGN_UP_FROM = 'Signup_From'; /* referrer site */
export const DISP_VIEW_NAME = 'Dispensary_View_Name'; /* last viewed disp */
export const DISP_VIEW_CITY = 'Dispensary_View_City'; /* last viewed disp city */
export const ORDER_PICKUP = 'Order_Pickup';
export const ORDER_DELIVERY = 'Order_Delivery';
export const ORDER_REFERRER = 'Order_Referrer';  /* if session started via external link */

// localhost user, ziprun-qa2 user, etc.
const buildDevUserObject = (userObj) => {
  const host = window.location.host.split('.')[0].split(':')[0];
  userObj.name = `${host} user`;         // Full name
  userObj.email = `${host}@ziprun.com`;  // Email address
  userObj.test_user = true;
  if (userObj.created_at) {
    userObj.created_at = 1617371938;     // Signup date timestamp (seconds)  
  }
  return userObj;
}

/**
 * Log an update for the user with Intercom. 
 * Users in DEV are consolidated into a single account for each ENV
 */ 
export const logWithIntercom = (name, email, created_at, actionObj) => {
  // Verify logged in user and Intercom API
  if (window.Intercom && email) {
    let userObj = { email };
    if (created_at) {
      userObj.created_at = created_at;
    }
    if (name) { /* likely don't need for updates */
      userObj.name = name;
    }
    // Override logging in DEV
    if (config.IS_DEV) {
      userObj = buildDevUserObject(userObj);
    }  
    const updateObj = Object.assign(userObj, actionObj);
    window.Intercom("update", updateObj);  
  } else {
    trackEvent('intercom_unable_to_log_action');
  } 
}; 